import { apiUtils } from '../utils/api';

export const getStaffList = async () => {
  return await apiUtils.get('staff/');
};

export const deleteStaff = async (id) => {
  return await apiUtils.delete(`staff/${id}/`);
};

export const updateStaff = async (id, data) => {
  const payload = {
    staff_name: data.staff_name,
    type_of_career: data.type_of_career,
    qualification: data.qualification,
  };
  return await apiUtils.put(`staff/${id}/`, payload);
};
